import type { DashboardOverviewRecord } from '@shared/types';

export function formatCurrency(locale: string, value: number, currency: string): string {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    maximumFractionDigits: 0
  }).format(value);
}

export function formatShortDate(locale: string, value: string): string {
  return new Intl.DateTimeFormat(locale, {
    day: 'numeric',
    month: 'short'
  }).format(new Date(value));
}

export function selectTaskChartSegments(overview: DashboardOverviewRecord, t: (key: string) => string) {
  return overview.taskStatusOverview.segments.map((segment) => ({
    ...segment,
    label: t(`enums.taskStatus.${segment.status}`)
  }));
}
